<script>

export default {
    name: 'ticker',

    props: {
    },

    data: function() {
        return {
            speed: 0.2,
            content: null,
		};
    },


    mounted: function() {
        document.body.classList.add('has-ticker');
        this.content = this.$refs.content.innerHTML;
        this.init();
        this.anim();
    },


	methods: {
        init() {
            const _self = this;
            const target_width =  _self.$el.offsetWidth * 2;

            while (_self.$refs.content.offsetWidth < target_width) {
                _self.$refs.content.insertAdjacentHTML('beforeend', _self.content);
            }
		},

        anim() {
            const _self = this;
			let left = 0;

            setInterval(function () {
                _self.$refs.content.style.marginLeft = `-${left}px`;
                if (left > _self.$el.offsetWidth) {
                    left = 0;
                }
                left = left + _self.speed;
            }, 0);
		}
	}
};
</script>